export default function init(container: HTMLElement) {
    const lateralNavigation = container.querySelector('.lateral-navigation') as HTMLElement;
    const footer = container.querySelector('.site-footer') as HTMLElement;
    const copyright = container.querySelector('.copyright') as HTMLElement;
    setup();
    function updatePosition() {
        if (!lateralNavigation || !footer) return;
        const footerRect = footer.getBoundingClientRect();
        if (footerRect.top <= window.innerHeight) {
            lateralNavigation.classList.remove('is-fixed');
        } else {
            lateralNavigation.classList.add('is-fixed');
        }
    }

    function setup() {
        if (!lateralNavigation || !footer) return;
        const WW = window.innerWidth;
        if (WW > 960) {
            const heightFooter = footer.scrollHeight;
            lateralNavigation.style.setProperty('--heightFooter', `${heightFooter}px`);
            if (copyright) {
                const heightCopyright = copyright.scrollHeight;
                lateralNavigation.style.setProperty('--heightCopyright', `${heightCopyright}px`);
            }
            updatePosition();
        }
        window.addEventListener('scroll', updatePosition);
    }
}
